__turbopack_context__.v({
  "boatNameContainer": "BoatColumn-module-scss-module__kqKe9W__boatNameContainer",
});
